
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { HeraBaseService, ISupportPlatform } from "./HeraBaseService";

export enum SupportResourceType {

    VIDEO = "VIDEO",
    ARTICLE = "ARTICLE",
    DOCUMENT = "DOCUMENT",

}

export interface ISupportResource {
    language: string;
    platform_id: string;
    external_id: string;
    description: string;
    url_location: string;
    type: SupportResourceType;
    platform: ISupportPlatform;
}

export class SupportResourceService extends HeraBaseService {

    protected static instance: SupportResourceService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportResourceService.instance) SupportResourceService.instance = new SupportResourceService();
        return SupportResourceService.instance;
    }

    querySupportResources(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ISupportResource>> {
        params["platform.platform_id"] = params.platform_id;
        delete params.platform_id;
        return this.report(this.transport.get("/hera/api/v1/support/resource", { query: this.normalizeParams(params) }));
    }

    createSupportResource(supportResource: Partial<ISupportResource>): Promise<SanitizedResponse<ISupportResource>> {
        return this.report(this.transport.post("/hera/api/v1/support/resource", supportResource));
    }

    updateSupportResource(supportResource: Partial<ISupportResource>): Promise<SanitizedResponse<ISupportResource>> {
        return this.report(this.transport.patch(`/hera/api/v1/support/resource/${supportResource.external_id}`, supportResource));
    }

    deleteSupportResource(id: string): Promise<SanitizedResponse<ISupportResource>> {
        return this.report(this.transport.delete(`/hera/api/v1/support/resource/${id}`));
    }

}

